/** Turns a two-letter country code into its flag emoji via regional indicators. */
export const countryFlag = (code) => {
  if (!code || code.length !== 2) return '🌐';
  const base = 0x1f1e6;
  return String.fromCodePoint(
    ...[...code.toUpperCase()].map((char) => base + char.charCodeAt(0) - 65),
  );
};

export const verdictMeta = {
  accessible: { label: 'Accessible', tone: 'ok' },
  'likely-blocked': { label: 'Likely blocked', tone: 'warn' },
  blocked: { label: 'Blocked', tone: 'bad' },
  // The request never left the country, so the origin's own policy is unknown.
  'isp-blocked': { label: 'Intercepted by ISP', tone: 'bad' },
};

export const healthMeta = {
  healthy: { label: 'Healthy', tone: 'ok' },
  degraded: { label: 'Degraded', tone: 'warn' },
  down: { label: 'Down', tone: 'bad' },
  unknown: { label: 'Not checked', tone: 'muted' },
};

export const formatLatency = (ms) => (ms === null || ms === undefined ? '—' : `${ms} ms`);

export const formatTime = (iso) => {
  if (!iso) return 'never';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? 'never' : date.toLocaleTimeString();
};
